<div class="container">
    <div class="header">
        <h6 class="title">
            {{ 'system-settings.fu.title-no' | translate: { num: index } }}
        </h6>
        <div class="options">
            <div #errorPopup class="error-icon">
                <mat-icon svgIcon="save-error" *ngIf="getIPErrors() != 0" (click)="toggleError()" />
                <div class="info-message-container" *ngIf="errorMessageVisible">
                    <div>
                        {{
                            'system-settings.fu.main.error-icon.text.' + (getIPErrors() === 1 ? 'one' : 'other')
                                | translate
                        }}
                    </div>
                </div>
            </div>
            <div (click)="openMoreOption()" #moreOptions>
                <mat-icon class="more-icon" svgIcon="more-options"></mat-icon>
                <div class="options-dialog" [class.show]="isOpenOption">
                    <div class="options-item" (click)="copy(); $event.stopPropagation()" [class.disabled]="!canCopy">
                        {{ 'system-settings.fu.more-option.copy' | translate }}
                    </div>
                    <div class="options-item" (click)="clear(); $event.stopPropagation()">
                        {{ 'system-settings.fu.more-option.clear' | translate }}
                    </div>
                    <div class="options-item" (click)="deleteFuData(); $event.stopPropagation()">
                        {{ 'system-settings.fu.more-option.delete' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content">
        <app-system-setting-dropdown
            [name]="COMMUNICATION_TYPE"
            label="system-settings.fu.label.communication"
            [itemList]="[SERIAL, LAN]"
            [value]="selectedCommunicationType"
            (onInputChange)="selectInput($event)"
            [dropdownWidth]="'180px'">
        </app-system-setting-dropdown>
        <app-system-setting-input
            class="input"
            [class.disable]="selectedCommunicationType !== LAN"
            [name]="FIELD_NET_A_IP"
            label="system-settings.fu.label.field-net-line-A-ip"
            [value]="fieldNetLineAIp"
            (onInputChange)="inputChange($event)"
            [inputErrorMessage]="validationErrors?.fieldNetLineAIp?.message"
            [maxLength]="15">
        </app-system-setting-input>
        <app-system-setting-input
            class="input"
            [class.disable]="selectedCommunicationType !== LAN"
            [name]="FIELD_NET_B_IP"
            label="system-settings.fu.label.field-net-line-B-ip"
            [value]="fieldNetLineBIp"
            (onInputChange)="inputChange($event)"
            [inputErrorMessage]="validationErrors?.fieldNetLineBIp?.message"
            [maxLength]="15">
        </app-system-setting-input>
        <app-system-setting-input
            class="input"
            [name]="LOCATION"
            label="system-settings.fu.label.location"
            [value]="location"
            (onInputChange)="inputChange($event)"
            [inputErrorMessage]="validationErrors?.location?.message"
            [maxLength]="16">
        </app-system-setting-input>
        <app-system-setting-dropdown
            [name]="SLOT_COUNT"
            label="system-settings.fu.label.slot-count"
            [itemList]="FU_SLOT_COUNTER_OPTIONS"
            [value]="selectedSlotCounter"
            (onInputChange)="selectInput($event)"
            [dropdownWidth]="'68px'">
        </app-system-setting-dropdown>
        <app-system-setting-dropdown
            *ngFor="let slot of slotList"
            class="slot-dropdown"
            [id]="slot.id"
            [class.disable]="!slot.enable"
            [name]="'Slot ' + slot.no"
            [label]="getEmptySlotLabel(slot.no)"
            [emptyItem]="EMPTY_SLOT"
            [itemList]="FU_SLOT_OPTIONS"
            [value]="slot.ioType === '' ? EMPTY_SLOT : slot.ioType"
            [selectedValues]="getSlotValue(slot)"
            [displayEdit]="true"
            (onInputChange)="selectSlotOption($event)"
            [dropdownWidth]="'200px'">
        </app-system-setting-dropdown>
    </div>
</div>
